import { Button, message } from "antd";
import React from "react";

const DownloadButton = ({ url, fileName, filetype }) => {
  const handleDownload = () => {
    message.info("Starting your donwload");
    fetch(url)
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement("a");
        link.href = url;
        link.download = fileName || "report.csv";
        document.body.appendChild(link);

        link.click();

        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => {
        console.error("Error fetching the file:", error);
      });
  };

  return (
    <div>
      <Button onClick={handleDownload}>Download {filetype}</Button>
    </div>
  );
};

export default DownloadButton;
